<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="5"
        lg="4"
      >
        <equipe-info-panel
          :key="equipeData.id"
          :equipe-data="equipeData"
          :acesso-put="acessoPut"
          :agentes="agentes"
          @refresh-data="
            getEquipe()
            getAssociacoes()
          "
        />
      </v-col>

      <v-col
        cols="12"
        md="7"
        lg="8"
      >
        <v-tabs
          v-model="activeTab"
          show-arrows
          grow
          class="user-tabs"
          @click="getEquipes()"
        >
          <v-tab
            v-for="tab in tabs"
            :key="tab.icon"
          >
            <v-icon
              size="20"
              class="me-3"
            >
              {{ tab.icon }}
            </v-icon>

            <span>{{ tab.title }}</span>
          </v-tab>
          <v-tab
            :to="{ name: 'equipes' }"
          >
            <v-icon color="error">
              {{ icons.mdiCloseCircleOutline }}
            </v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items
          id="user-tabs-content"
          v-model="activeTab"
          class="mt-5 pa-1"
        >
          <v-tab-item>
            <equipe-tab-agentes
              :ativo="equipeData.ativo"
              :items="agentes"
              :headers="headers"
              :loading="loading"
              @refetch-data="
                getEquipe()
                getAssociacoes()
              "
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiAlertCircleOutline, mdiCloseCircleOutline } from '@mdi/js'
import { mapState } from 'pinia'
import EquipeInfoPanel from '@/views/equipe/EquipeInfoPanel.vue'
import EquipeTabAgentes from '@/views/equipe/EquipeTabAgentes.vue'
import router from '@/router'
import useAuthStore from '@/store/auth'
import EquipeService from '@/services/modules/EquipeService'

export default {
  components: {
    EquipeInfoPanel,
    EquipeTabAgentes,
  },

  data: () => ({
    agentes: [],
    equipeData: {},
    dialogSalvar: false,
    loading: true,
    idfuncao: 1,
    headers: [
      { text: 'NOME', value: 'nome' },
      { text: 'ATUAÇÃO', value: 'atuacao' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ],
    idPut: 1087,
    acessoPut: true,
  }),

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    this.getEquipe()
    this.getAssociacoes()
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPut)) {
        this.acessoPut = false
      }
    },

    async getEquipe() {
      this.equipeData = await EquipeService.getById(router.currentRoute.params.id)
    },

    async getAssociacoes() {
      try {
        this.loading = true

        const data = await EquipeService.getAgentesAssociadosAEquipe(router.currentRoute.params.id)
        this.agentes = data

        setTimeout(() => {
          this.loading = false
        }, 1000)
      } catch {
        this.loading = false
      }
    },
  },

  setup() {
    const activeTab = ref(0)

    const tabs = [
      { icon: mdiAlertCircleOutline, title: 'Usuários' },
    ]

    return {
      tabs,
      activeTab,
      icons: {
        mdiCloseCircleOutline,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
